export enum UserHeaders {
  fullName = 'Name',
  emailName = 'Email',
  userTypeName = 'User Type',
  districtName = 'District',
  schoolName = 'School'
}

export enum UserProps {
  'First Name' = 'FirstName',
  'Last Name' = 'LastName',
  'Email' = 'Email'
}
